import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
const OkIcon = ({ className }) => (_jsx("svg", Object.assign({ className: `svg-ok-icon ${className}`, height: '12.166', viewBox: '0 0 14.028 12.166', width: '14.028', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsx("path", { d: 'M-843.5,6367.469l4.688,5.156,3.274-4.191,4.538-5.809', fill: 'none', stroke: '#bdbdbd', strokeWidth: '2', transform: 'translate(844.24 -6362.009)' }) })));
OkIcon.propTypes = {
    className: propStr(),
};
OkIcon.defaultProps = {
    className: '',
};
export default OkIcon;
